import React, {useState} from "react";
import {Box} from "@mui/system";
import BasicActionButton from "../../../common/BasicActionButton";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import {Switch, Typography} from "@mui/material";

export default function ChannelCard({label, description, icon, onClick, allowTestInstanceConnection = false}){
    const [connectTestEnv, setConnectTestEnv] = useState(false)
    const toggleTestInstance = () =>{
        setConnectTestEnv(!connectTestEnv);
    }
    return(
        <Box component={'li'} sx={styles.listItemWrapper}>
            <Box sx={styles.logoWrapper}>
                {icon ? <Box component={'img'} sx={styles.logo} src={icon} alt={`${label} Logo`} /> : 'Logo'}
            </Box>
            <Box sx={styles.content}>
                <Box>
                    <Box component={'h2'} sx={styles.contentLabel}>
                        {label}
                    </Box>
                    <Box component={'p'} sx={styles.description}>
                        {description}
                    </Box>
                    {allowTestInstanceConnection &&
                        <Box>
                            <FormControlLabel
                                control={<Switch onChange={toggleTestInstance} sx={styles.switch}/>}
                                label={<Typography sx={styles.instanceLabel}>
                                    Test Instance
                            </Typography>}/>
                        </Box>
                    }
                </Box>
                <BasicActionButton sx={styles.connectButton} action={onClick}  label={connectTestEnv ? 'Connect Test Instance' : 'Connect'} />
            </Box>
        </Box>
    )
}

const styles = {
    listItemWrapper: {
        py: { xs: 2, sm: 3 },
        px: {xs: 2, sm: 0},
        display: 'flex',
        alignItems: 'center',
        borderRadius: 0,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: '#0F0A0533',
        backgroundColor: '#FFF',
        borderTopWidth: { xs: 1, sm: 0 },
        gap: { xs: 1.5, sm: 4 },
        '&:first-of-type': {borderTopWidth: 1},
        '&:last-of-type': {borderBottom: 'none'}
    },
    logoWrapper: {
        height: { xs: '40px', sm: '60px' },
        width: { xs: '40px', sm: '60px' },
        flexShrink: 0,
        alignSelf: { xs: 'flex-start', md: 'center' },
    },
    logo: {
        height: '100%',
        width: '100%',
    },
    content: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: { xs: 0, sm: 4 },
        flexDirection: { xs: 'column', sm: 'row' },
    },
    contentLabel: {
        fontFamily: 'FustatBold',
        fontSize: '16px',
        lineHeight: 1.2,
        letterSpacing: '0.01em',
        color: '#0F0A05',
        textTransform: 'uppercase',
        mt: 0,
        mb: { xs: 0, sm: 0.5 },
    },
    description: {
        fontFamily: 'FustatRegular',
        fontSize: '16px',
        lineHeight: 1.2,
        color: '#0F0A05',
        m: 0
    },
    connectButton: {
        alignSelf: { xs: 'flex-start', sm: 'center' },
        width: { xs: '100%', sm: 'auto' },
        ml: { xs: 0, sm: 2 },
        mt: { xs: 1, sm: 0 },
    },
}